import { useAppSelector } from "integrations/redux/hooks"
import { selectSatelliteFlightById } from "features/entity-caching/flights/selectors"
import { InspectorPanelAccordionExport } from "../accordion/export/InspectorPanelAccordionExport"
import { useSatelliteDownloadButtonData } from "plugins/Satellite/useSatelliteDownloadButtonData"
import { SatelliteMetadataRows } from "./SatelliteMetadataRows"

export const InspectorPanelSatelliteData = ({ id }: { id: string }) => {
    const flight = useAppSelector(selectSatelliteFlightById(id))
    const downloadOptions = useSatelliteDownloadButtonData(id)

    if (!flight) return null

    return (
        <div className="mb-2 flex flex-col gap-2">
            <InspectorPanelAccordionExport
                exportOptions={downloadOptions.exportOptions}
                canOnlyPickOne={true}
            />

            <div className="mx-4">
                <SatelliteMetadataRows flight={flight} />
            </div>
        </div>
    )
}
